import React from "react";
import { Row, Col, Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import mainImage from "../../assets/focus.jpg"; // ✅ New main image for Open Events
import card1 from "../../assets/bloom-main.jpg"; // ✅ Bloom card
import card2 from "../../assets/jui-news-image.png"; // ✅ Jiu-jitsu card
import card3 from "../../assets/heroes-cup.jpg"; // ✅ Heroes Cup card

const { Title, Paragraph, Text } = Typography;

const OpenEventsDetail = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/news");
  };

  const handleBloomDayClick = () => {
    navigate("/news/bloom-day");
  };

  const handleJiuJitsuClick = () => {
    navigate("/news/jiu-jitsu");
  };

  const handleHeroesCupClick = () => {
    navigate("/news/heroes-day");
  };

  return (
    <div style={{ background: "#fafafa", padding: "24px" }}>
      <Row gutter={[24, 24]} justify="center">
        {/* LEFT SIDE — Sidebar Cards */}
        <Col xs={24} md={8} lg={6}>
          {/* Header Card */}
          <Card
            style={{
              background: "#4b007d",
              color: "#fff",
              borderRadius: "10px",
              padding: "16px",
            }}
            bordered={false}
          >
            <Title level={4} style={{ color: "#fff", marginBottom: 4 }}>
              Yalla Nellab News
            </Title>
            <Text 
              style={{ color: "#d9d9d9", cursor: "pointer" }}
              onClick={handleViewAll}
            >
              View all
            </Text>
          </Card>

          {/* News Card 1 - Bloom Day */}
          <Card
            hoverable
            onClick={handleBloomDayClick}
            cover={
              <img
                alt="Bloom Day"
                src={card1}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Bloom Day: Yalla Nellab Announces a New Initiative for Special
              Children
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>

          {/* News Card 2 - Jiu-jitsu */}
          <Card
            hoverable
            onClick={handleJiuJitsuClick}
            cover={
              <img
                alt="Jiu-jitsu"
                src={card2}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Jiu-jitsu is Rising in the UAE
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>

          {/* News Card 3 - Heroes Cup */}
          <Card
            hoverable
            onClick={handleHeroesCupClick}
            cover={
              <img
                alt="Heroes Cup"
                src={card3}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Heroes Cup: Tournament dedicated to honoring laborers
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>
        </Col>

        {/* RIGHT SIDE — Open Events Article */}
        <Col xs={24} md={16} lg={18}>
          <div
            style={{
              borderRadius: 10,
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Purple overlay background */}
            <div
              style={{
                background:
                  "linear-gradient(to bottom, #4b007d 30%, transparent 70%)",
                borderRadius: 10,
                overflow: "hidden",
              }}
            >
              <img
                alt="Open Events"
                src={mainImage}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  opacity: 0.95,
                }}
              />
            </div>

            {/* Article content */}
            <div
              style={{
                background: "#fff",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                padding: "24px",
                marginTop: "8px",
              }}
            >
              <Title level={3}>Open Events: Community Games for Everyone</Title>

              <Title level={5}>Community Games for Everyone</Title>
              <Paragraph>
                At the core of Yalla Nellab lies the spirit of community and
                togetherness, brought to life through our Open Events. These
                open tournaments are designed for everyone — no professional
                contracts, no barriers, just pure passion for sports and
                connection.
              </Paragraph>

              <Title level={5}>Cricket, Football and Jiu-Jitsu</Title>
              <Paragraph>
                Our Open Events feature Cricket, Football and Jiu-Jitsu, giving
                players of all ages and skill levels a chance to participate,
                compete and grow. Whether it's a thrilling football match under
                the lights, a competitive cricket game on the field or an
                intense Jiu-Jitsu bout, every event is filled with energy,
                teamwork and excitement.
              </Paragraph>

              <Title level={5}>Building Bonds Through Sports</Title>
              <Paragraph>
                More than just games, these tournaments create friendships,
                promote fitness and unite communities. They bring together
                people from all walks of life who share one thing in common —
                the love of sport.
              </Paragraph>

              <Title level={5}>The Heart of Yalla Nellab</Title>
              <Paragraph>
                Open Events are not just competitions, they are the heart of
                Yalla Nellab, representing our mission to make sports
                accessible, inclusive and enjoyable for everyone. Here, every
                player belongs and every moment counts.
              </Paragraph>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default OpenEventsDetail;